import { render, staticRenderFns } from "./VGM.vue?vue&type=template&id=8516f466&scoped=true&"
import script from "./VGM.vue?vue&type=script&lang=js&"
export * from "./VGM.vue?vue&type=script&lang=js&"
import style0 from "./VGM.vue?vue&type=style&index=0&id=8516f466&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8516f466",
  null
  
)

export default component.exports